const styles = (theme: Object) => ({
  root: {
    width: '860px',
    borderRadius: '6px',
    boxShadow: '0 1px 1px 1px #b3b3b3',
    padding: '32px 23px',
    marginTop: '32px',
    backgroundColor: theme.palette.neutrals.background,
  },
  title: {
    margin: '0 0 24px',
    fontSize: '1.2rem',
    fontWeight: 500,
    color: theme.palette.neutrals.mainText,
  },
});

export default styles;
